<template>
    <b-form @submit="onSubmit">
        <div class="row mt-n4 sticky-top">
            <b-alert class="w-100" variant="info" show>

                <span v-if="selected.length > 0">
                    {{ $t('components.bulk_form.alterando') }}
                    <b-badge variant="info" pill>{{ selected.length }}</b-badge>
                    {{ $t('components.bulk_form.registros') }}
                </span>

                <b-form-group v-else :label="$t('components.bulk_form.label_quantidade')" label-cols-sm="8"
                              label-for="input-quantidade" class=" m-0">
                    <b-form-input id="input-quantidade" type="number" v-model="insert.quantity_record"
                                  @change="loadInserts" required/>
                </b-form-group>

            </b-alert>
        </div>

        <b-form-group v-if="selected.length > 0" v-for="field in fields"
                      label-cols-sm="3" :label-for="`input-${field.key}`">
            <template v-slot:label>
                <b-check v-model="enabled[field.key]">{{ field.label }}</b-check>
            </template>
            <slot :name="'field('+field.key+')'"
                  v-bind="{ enabled: enabled[field.key], model, id: field.key, id: `input-${field.key}` }">
                <b-form-input :id="`input-${field.key}`" v-model="model[field.key]"
                              :disabled="!enabled[field.key]" required/>
            </slot>
            <template v-if="field.description" v-slot:description>{{ field.description }}</template>
        </b-form-group>

        <div class="row">
            <div v-for="(models, insert_index) in insert.models" class="col-md-4 mb-3">
                <div class="border-info pl-3 pr-3">
                    <b-form-group v-for="field in fields" :label-for="`input-${field.key}-${insert_index}`">
                        <template v-slot:label>{{ field.label }}</template>
                        <slot :name="'field('+field.key+')'"
                              v-bind="{ enabled: true, model: insert.models[insert_index], id: `input-${field.key}-${insert_index}` }">
                            <b-form-input :id="`input-${field.key}-${insert_index}`"
                                          v-model="insert.models[insert_index][field.key]" required/>
                        </slot>
                        <template v-if="field.description" v-slot:description>
                            {{ field.description }}
                        </template>
                    </b-form-group>
                </div>
            </div>
        </div>

        <b-button type="submit" variant="success" block>
            <i class="fas fa-save"/> {{ $t('components.bulk_form.aplicar') }}
        </b-button>
    </b-form>
</template>

<script>
    export default {
        name: "BulkForm",
        props: {
            selected: {
                type: Array,
                default: () => []
            },
            fields: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {
                enabled: {},
                insert: {
                    quantity_record: null,
                    //fields: [],
                    models: []
                },
                model: {}
            }
        },
        methods: {
            loadInserts() {
                //let lista = []
                let model = []
                for (let i=0; i < this.insert.quantity_record; i++) {
                    //lista = [ ...lista, this.fields ]
                    model = [ ...model, {} ]
                }
                //this.insert.fields = lista
                this.insert.models = model
            },
            async onSubmit(evt) {
                evt.preventDefault()

                let data = {}
                if (this.selected.length > 0) {
                    // Update
                    Object.keys(this.enabled).map(key => {
                        if (key === 'ids'){
                            console.log('Atenção! chave já reservada pelo Componente!', key)
                            return;
                        }

                        if (this.enabled[key] && !this.model[key]) {
                            data[key] = null
                            return;
                        }

                        data[key] = (this.model[key] && this.model[key].value) ? this.model[key].value : this.model[key]
                    })
                    const ids = this.selected.map(item => item.id)
                    data = { ids, ...data }
                }else {
                    // Insert
                    if (this.insert.quantity_record <= 0) {
                        this.$snotify.error( this.$t('components.bulk_form.messages.quantidade') )
                        return
                    }

                    this.insert.models.map(model => {
                        Object.keys( model ).map(key => {
                            model[key] = (model[key] && model[key].value) ? model[key].value : model[key]
                        })
                    })

                    data = {
                        quantity_record: this.insert.quantity_record,
                        array: this.insert.models
                    }
                }

                this.$emit('persist', data)
            },
        }
    }
</script>

<style lang="scss" scoped>
    .border-info{
        border: .25rem solid #36b9cc!important;
    }
</style>
